import { useState, useRef } from "react";
import oInfo from "../info.json";

//Components
import MealComponent from "./MealComponent";

const PricingContainer = () => {
  const { sHeader, sSubHeader, oMenu } = oInfo.oPricingPage;
  const [oActiveBtn, fnSetActiveBtn] = useState("snack");
  const oButtonRow = useRef(null);

  const fnOnMealBtnClick = (event) => {
    event.preventDefault();
    oButtonRow.current.childNodes.forEach((btn) =>
      btn.classList.remove("active")
    );

    event.target.classList.toggle("active");
    fnSetActiveBtn(event.target.name);
  };
  return (
    <section className="flex-column card" id="pricing-section">
      <div className="flex-row flex-wrap flex-center">
        <h2 className="card-header">{sHeader}</h2>
        <h2 className="card-subheader banner-background">
          <span className="subheader-span">{sSubHeader}</span>
        </h2>
      </div>

      <div className="flex-row meal-row flex-wrap flex-center" ref={oButtonRow}>
        <button
          className="meal-btn active"
          onClick={fnOnMealBtnClick}
          name="snack"
        >
          Snack
        </button>
        <button
          className="meal-btn"
          onClick={fnOnMealBtnClick}
          name="breakfast"
        >
          Breakfast
        </button>
        <button className="meal-btn" onClick={fnOnMealBtnClick} name="lunch">
          Lunch
        </button>
        <button className="meal-btn" onClick={fnOnMealBtnClick} name="dinner">
          Dinner
        </button>
        <button className="meal-btn" onClick={fnOnMealBtnClick} name="dessert">
          Dessert
        </button>
      </div>
      <div className="flex-row flex-center flex-wrap">
        {oActiveBtn === "snack"
          ? oMenu.aSnacks.map((oItem) => (
              <MealComponent oData={oItem} key={oItem.sName} />
            ))
          : oActiveBtn === "breakfast"
          ? oMenu.aBreakfast.map((oData) => {
              return <MealComponent oData={oData} key={oData.sName} />;
            })
          : oActiveBtn === "lunch"
          ? oMenu.aLunch.map((oItem) => (
              <MealComponent oData={oItem} key={oItem.sName} />
            ))
          : oActiveBtn === "dinner"
          ? oMenu.aDinner.map((oItem) => (
              <MealComponent oData={oItem} key={oItem.sName} />
            ))
          : oMenu.aDessert.map((oItem) => (
              <MealComponent oData={oItem} key={oItem.sName} />
            ))}
      </div>
    </section>
  );
};

export default PricingContainer;
